<span class="linear-wipe !bg-clip-text text-base font-medium text-transparent">
  <slot />
</span>

<style lang="scss">
  .linear-wipe {
    background: linear-gradient(
      90deg,
      #e02020 0%,
      #fa6400 16.72%,
      #f7b500 33.39%,
      #6dd400 50.05%,
      #0091ff 66.57%,
      #6236ff 83.32%,
      #b620e0 100%
    );
    background-size: 200% 100%;
    background-position: 100% 0;

    animation: gradient-flip 4.5s ease infinite;
  }

  @keyframes gradient-flip {
    0% {
      background-position: 0% 50%;
    }

    50% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0% 50%;
    }
  }
</style>
